export const fetchConditionalPropertyOptionRules = (objectTypeId, http, offset) => {
  return http.get(`conditional-properties/v2/options/${objectTypeId}/unmerged/paged`, {
    query: {
      pageSize: 100,
      offset
    }
  }).then(conditionalPropertyOptionRules => {
    const {
      results,
      hasMore,
      offset: newOffset
    } = conditionalPropertyOptionRules;

    if (hasMore) {
      return fetchConditionalPropertyOptionRules(objectTypeId, http, newOffset).then(moreRules => results.concat(moreRules));
    }

    return results;
  }).catch(err => {
    //Todo: Sentry once Raven is setup in CDP
    console.log(err);
    throw err;
  });
};